import React from "react";
import Navbar from "../components/navbar";
import Intro from '../components/intro'
import About from '../components/about'
import Tech from '../components/tech'
import Experiance from '../components/experiance'
import Project from '../components/project'
import Footer from '../components/footer'
import Cursor from '../components/cursor'
import { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import '../style/loader.css'
import '../style/home.css'



const Home = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="cssload-wrap">
          <div className="cssload-cssload-spinner"></div>
        </div>
      ) : (
        <>
        <Navbar />
        <Intro />
        <About />
        <Tech />
        <Experiance />
        <Project />
        <Footer />
        <Cursor/>
        </>
      )}
    </>
  );
};
export default Home;
